import {
  createBrowserRouter,
  isRouteErrorResponse,
  useRouteError,
} from 'react-router-dom';
import {
  ActivityView,
  ArticleView,
  BrowseView,
  CoursesView,
  CourseView,
  CreatePathwayView,
  CredentialsView,
  CredentialView,
  IndexView,
  PathwaysView,
  PathwayView,
  ProgramsView,
  ProgramView,
  PublicProfileView,
  RecommendedView,
  SkillsView,
} from './views';
import Error403 from './errors/pages/error403';
import Error404 from './errors/pages/error404';
import DashboardView from './views/DashboardView/DashboardView';
import ProfileView from './views/ProfileView';
import { jwtIsValid, Logout, SsoLogin } from '@iblai/ibl-web-react-common';
import CourseIframeCourseContentView from './views/content/CourseIframeCourseContentView/CourseIframeCourseContentView';
import CourseIframeCourseTabView from './views/content/CourseIframeCourseTabView/CourseIframeCourseTabView';
import { inIframe } from './utils/helpers';
import StaticClassView from './views/StaticClassView';
import { isStaticPagesEnabled } from './hooks/helpers';
const STATIC_PAGES_ENABLED = isStaticPagesEnabled()

const authCheckFn = (isAdmin, isLoggedIn, appData) => {
  return () => {
    if (
      isAdmin &&
      (!appData.hasOwnProperty('current_tenant') ||
        !appData.current_tenant.is_admin)
    ) {
      throw new Response('Not Admin', { status: 403 });
    }
    if (
      isLoggedIn &&
      (!appData.hasOwnProperty('token') ||
        !appData?.token.length ||
        !jwtIsValid(appData.token))
    ) {
      if (!inIframe()) {
        window.location.href = `${process.env.REACT_APP_IBL_SPA_AUTH_URL}/login?redirect-to=${window.location.origin}/sso-login`;
      }
      return;
    }
    return [];
  };
};

const ErrorPage = () => {
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    console.log('ERROR : ', error);
    if (error.status === 404) {
      return <Error404 />;
    } else if (error.status === 403) {
      return <Error403 />;
    }
  }
};

const route = (appData) => {

  const routes = [
    {
      path: '/',
      errorElement: <ErrorPage />,
      children: [
        ...(STATIC_PAGES_ENABLED ? [
          {
            path: '',
            element: <StaticClassView />,
            loader: authCheckFn(false, false, appData),
          },
          {
            path: 'public',
            element: <StaticClassView />,
            loader: authCheckFn(false, false, appData),
            children: [
              {
                path:":publicPath",
                element: <StaticClassView />,
              }
            ]
          }] : []),
        {
          path: '',
          element: <DashboardView />,
          loader: authCheckFn(false, true, appData),
          children: [
            {
              path: `${STATIC_PAGES_ENABLED ? `${process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED_DASHBOARD_PATH}` : ""}`,
              element: <IndexView />,
            },
            {
              path: 'profile',
              element: <ProfileView />,
              children: [
                {
                  path: 'activity',
                  element: <ActivityView />,
                },
                {
                  path: 'credentials',
                  element: <CredentialsView />,
                },
                {
                  path: ':credentials/:credentialID',
                  element: <CredentialView />,
                },
                {
                  path: 'pathways/:pathwayID',
                  element: <PathwayView />,
                },
                {
                  path: 'pathways/new',
                  element: <CreatePathwayView />,
                },
                {
                  path: 'skills',
                  element: <SkillsView />,
                },
                {
                  path: 'pathways',
                  element: <PathwaysView />,
                },
                {
                  path: 'courses',
                  element: <CoursesView />,
                },
                {
                  path: 'programs',
                  element: <ProgramsView />,
                },
                {
                  path: 'public-profile',
                  element: <PublicProfileView />,
                },
              ],
            },
            {
              path: 'courses/:courseID',
              element: <CourseView />,
            },
            {
              path: 'programs/:programID',
              element: <ProgramView />,
            },
            {
              path: 'courses/:courseID',
              element: <ArticleView />,
              children: [
                {
                  path: 'course',
                  element: <CourseIframeCourseContentView />,
                },
                {
                  path: ':tab', // Matches any subpath not matched by above
                  element: <CourseIframeCourseTabView />,
                },
              ],
            },
            {
              path: 'recommended',
              element: <RecommendedView />,
            },
            {
              path: 'discover',
              element: <BrowseView />,
            },

          ],
        },
        {
          path: 'sso-login',
          element: <SsoLogin />,
          loader: authCheckFn(false, false, appData),
        },
        {
          path: 'logout',
          element: (
            <Logout
              redirectTo={ STATIC_PAGES_ENABLED ? window.location.origin : `${process.env.REACT_APP_IBL_SPA_AUTH_URL}/login?redirect-to=${window.location.origin}/sso-login`}
            />
          ),
          loader: authCheckFn(false, false, appData),
        },
      ],
    },
  ];

  return createBrowserRouter(routes);
};

export default route;
